<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>

                    <form @submit.prevent="addData($event)">
                        <div class="row">
                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>نام</label>
                                    <input type="text" name="title" v-model="info.title" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 my-1">
                                <label class="sr-only" for="inline-form-input-name"> دسته بندی</label>
                                <a-select  mode="multiple" style="width:100%" placeholder="انتخاب دسته بندی " v-model="info.categories"
                                    >
                                    <a-select-option v-for="cat in cats" :key="cat.id" :value="cat.id">
                                        {{ cat.title}}
                                    </a-select-option>
                                </a-select>
                            </div>
                            


                            <hr class="m-5">


                        </div>
                        <div class="card-footer  ">
                            <div class="row ">
                                <div class="col-md-10"></div>
                                <div class="col-md-1 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>
                                </div>
                               
                                <div class="col-md-1 ">
                                    <router-link to="/specifications/list"
                                        class="btn btn-fill btn-outline-danger w-100">بازگشت</router-link>
                                </div>

                            </div>

                        </div>
                    </form>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
       
        data() {
            return {
                info: {
                },
                cats: [],
            };
        },
        mounted() {
            this.getCats();
           
        },
        methods: {
            
            async getCats() {
                let _this = this;
                let url = '/categories/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.cats = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },


            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                data.append('status', 1);
                data.append('categories', this.info.categories);
                _this.$root.loading = true;
                axios
                    .post("/specifications/add", data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success("مشخصه با موفقیت ذخیره شد");
                        _this.$router.push("/specifications/list");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
    };
</script>
